import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from '../../shared/shared.module';
import { HelpTextComponent } from './HelpText/HelpText.component';
import { HelpTextEditorComponent } from './HelpTextEditor/HelpTextEditor.component';
import { CustomerFilesComponent } from './customer-files/customer-files.component';
import { CredentialsComponent } from './customer-account/credentials/credentials.component';
import { SiteCredentialsComponent } from './customer-account/site-credentials/site-credentials.component';
import { ValidationChecklistComponent } from './ValidationChecklist/ValidationChecklist.component';
import { CustomReportsComponent } from './CustomReports/CustomReports.component';
import { CompositionRouteGridComponent } from './CompositionRouteGrid/CompositionRouteGrid.component';
import { EmptyComponent } from './empty/empty.component';
import { LanguageQuestionGroupComponent } from './LanguageQuestionGroup/LanguageQuestionGroup.component';
import { TimeZoneDateTimeComponent } from './time-zone-date-time/time-zone-date-time.component';
import { VerticalSelectorComponent } from './VerticalSelector/VerticalSelector.component';
import { UploadFileComponent } from './UploadFile/UploadFile.component';
import { ODataGridComponent } from './o-data-grid/o-data-grid.component';
import { OptionToggleComponent } from './OptionToggle/OptionToggle.component';
import { PublishOptionsComponent } from './publish-options/publish-options.component';
import { PagerComponent } from './Pager/Pager.component';
import { RecentOrdersComponent } from './RecentOrders/RecentOrders.component';
import { CmsSelectionComponent } from '../managecustomer/WebsiteAccess/Cms/CmsSelection.Component';
import { DudaSiteAdminSSOButtonComponent } from '../websites/DudaSiteAdminSSOButton/DudaSiteAdminSSOButton.Component';
import { ChecklistComponent } from './Checklist/checklist/checklist.component';
import { UpaChecklistComponent } from './Checklist/upa-checklist/upa-checklist.component';
import { AddressComponent } from './local-profiles/address/address.component';
import { AttributesComponent } from './local-profiles/attributes/attributes.component';
import { BusinessCitationSubscriptionsComponent } from './local-profiles/business-citation-subscriptions/business-citation-subscriptions.component';
import { LocalProfilesComponent } from './local-profiles/local-profiles/local-profiles.component';
import { LocalProfileComponent } from './local-profiles/local-profile/local-profile.component';
import { LocalProfileInitializationComponent } from './local-profiles/local-profile-initialization/local-profile-initialization.component';
import { MinimumLocalProfileComponent } from './local-profiles/minimum-local-profile/minimum-local-profile.component';
import { LocalProfileListComponent } from './local-profiles/local-profile-list/local-profile-list.component';
import { ViewLocalProfilesComponent } from './local-profiles/view-local-profiles/view-local-profiles.component';
import { ViewLocalProfileComponent } from './local-profiles/view-local-profile/view-local-profile.component';
import { ViewLocalProfileListComponent } from './local-profiles/view-local-profile-list/view-local-profile-list.component';
import { TaskFilesComponent } from './task-files/task-files.component';
import { NotificationModalComponent } from './notification-modal/notification-modal.component';
import { NotificationTemplateComponent } from './notification-template/notification-template.component';
import { NotificationDefinitionComponent } from './notification-definition/notification-definition.component';
import { MinimumCustomerCampaignComponent } from './minimum-customer-campaign/minimum-customer-campaign.component';
import { CustomerCampaignComponent } from './customer-campaign/customer-campaign/customer-campaign.component';
import { CampaignSummaryComponent } from './customer-campaign/campaign-summary/campaign-summary.component';
import { PagesAndKeywordsComponent } from './customer-campaign/pages-and-keywords/pages-and-keywords.component';
import { PageComponent } from './customer-campaign/page/page.component';
import { KeywordComponent } from './customer-campaign/keyword/keyword.component';
import { TrackingKeywordsComponent } from './customer-campaign/tracking-keywords/tracking-keywords.component';
import { TrackingKeywordComponent } from './customer-campaign/tracking-keyword/tracking-keyword.component';
import { ArchivedKeywordsComponent } from './customer-campaign/archived-keywords/archived-keywords.component';
import { ArchivedPagesComponent } from './customer-campaign/archived-pages/archived-pages.component';
import { OnsiteTaskInformationComponent } from './customer-campaign/onsite-task-information/onsite-task-information.component';
import { MinorEditsOrderComponent } from './customer-campaign/minor-edits-order/minor-edits-order.component';
import { TaskApprovalComponent } from './customer-campaign/task-approval/task-approval.component';
import { AddPageComponent } from './customer-campaign/add-page/add-page.component';
import { AddKeywordComponent } from './customer-campaign/add-keyword/add-keyword.component';
import { PageStatusComponent } from './customer-campaign/page-status/page-status.component';
import { PageUpdateComponent } from './customer-campaign/page-update/page-update.component';
import { KeywordResearchComponent } from './keyword-research/keyword-research/keyword-research.component';
import { AddKeywordComponent as KeywordResearchAddKeywordComponent } from './keyword-research/add-keyword/add-keyword.component';
import { AddTrackingKeywordComponent as KeywordResearchAddTrackingKeywordComponent } from './keyword-research/add-tracking-keyword/add-tracking-keyword.component';
import { AddPageComponent as KeywordResearchAddPageComponent } from './keyword-research/add-page/add-page.component';
import { KeywordComponent as KeywordResearchKeywordComponent } from './keyword-research/keyword/keyword.component';
import { KeywordSuggestionFilterComponent as KeywordResearchKeywordSuggestionFilterComponent } from './keyword-research/keyword-suggestion-filter/keyword-suggestion-filter.component';
import { PageComponent as KeywordResearchPageComponent } from './keyword-research/page/page.component';
import { PageStatusComponent as KeywordResearchPageStatusComponent } from './keyword-research/page-status/page-status.component';
import { PagesAndKeywordsComponent as KeywordResearchPagesAndKeywordsComponent } from './keyword-research/pages-and-keywords/pages-and-keywords.component';
import { TrackingKeywordComponent as KeywordResearchTrackingKeywordComponent } from './keyword-research/tracking-keyword/tracking-keyword.component';
import { TrackingKeywordsComponent as KeywordResearchTrackingKeywordsComponent } from './keyword-research/tracking-keywords/tracking-keywords.component';
import { SummaryComponent as KeywordResearchSummaryComponent} from './keyword-research/summary/summary.component';
import { AddKeywordResearchComponent as KeywordResearchAddKeywordResearchComponent } from './keyword-research/add-keyword-research/add-keyword-research.component';
import { ProcessKeywordResearchComponent as KeywordResearchProcessKeywordResearchComponent } from './keyword-research/process-keyword-research/process-keyword-research.component';
import { SeoActionPlanComponent as KeywordResearchSeoActionPlanComponent } from './keyword-research/seo-action-plan/seo-action-plan.component';
import { GoogleIntegrationInfoComponent } from './google/google-integration-info/google-integration-info.component';
import { FormsModule } from '@angular/forms';
import { GoogleIntegrationDiagnosticComponent } from './google/google-integration-diagnostic/google-integration-diagnostic.component';
import { GoogleIntegrationDiagnosticPanelComponent } from './google/google-integration-diagnostic-panel/google-integration-diagnostic-panel.component';

@NgModule({
  declarations: [
    ValidationChecklistComponent,
    CmsSelectionComponent,
    CustomerFilesComponent,
    TaskFilesComponent,
    CustomReportsComponent,
    CredentialsComponent,
    CompositionRouteGridComponent,
    DudaSiteAdminSSOButtonComponent,
    EmptyComponent,
    HelpTextComponent,
    HelpTextEditorComponent,
    LanguageQuestionGroupComponent,
    AddressComponent,
    AttributesComponent,
    BusinessCitationSubscriptionsComponent,
    LocalProfilesComponent,
    LocalProfileListComponent,
    LocalProfileComponent,
    LocalProfileInitializationComponent,
    MinimumLocalProfileComponent,
    ViewLocalProfilesComponent,
    ViewLocalProfileComponent,
    ViewLocalProfileListComponent,
    ODataGridComponent,
    OptionToggleComponent,
    PagerComponent,
    PublishOptionsComponent,
    RecentOrdersComponent,
    SiteCredentialsComponent,
    TimeZoneDateTimeComponent,
    UploadFileComponent,
    VerticalSelectorComponent,
    ChecklistComponent,
    UpaChecklistComponent,
    NotificationModalComponent,
    NotificationTemplateComponent,
    NotificationDefinitionComponent,
    MinimumCustomerCampaignComponent,
    MinorEditsOrderComponent,
    CustomerCampaignComponent,
    CampaignSummaryComponent,
    PagesAndKeywordsComponent,
    PageComponent,
    KeywordComponent,
    TrackingKeywordsComponent,
    TrackingKeywordComponent,
    ArchivedKeywordsComponent,
    ArchivedPagesComponent,
    OnsiteTaskInformationComponent,
    TaskApprovalComponent,
    AddPageComponent,
    AddKeywordComponent,
    PageStatusComponent,
    PageUpdateComponent,
    KeywordResearchComponent,
    KeywordResearchAddKeywordComponent,
    KeywordResearchAddTrackingKeywordComponent,
    KeywordResearchAddPageComponent,
    KeywordResearchKeywordComponent,
    KeywordResearchKeywordSuggestionFilterComponent,
    KeywordResearchPageComponent,
    KeywordResearchPageStatusComponent,
    KeywordResearchPagesAndKeywordsComponent,
    KeywordResearchTrackingKeywordComponent,
    KeywordResearchTrackingKeywordsComponent,
    KeywordResearchSummaryComponent,
    KeywordResearchAddKeywordResearchComponent,
    KeywordResearchProcessKeywordResearchComponent,
    KeywordResearchSeoActionPlanComponent,
    GoogleIntegrationInfoComponent,
    GoogleIntegrationDiagnosticComponent,
    GoogleIntegrationDiagnosticPanelComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    DragDropModule
  ],
  exports: [
    HelpTextComponent,
    HelpTextEditorComponent,
    RecentOrdersComponent,
    CmsSelectionComponent,
    CustomerFilesComponent,
    TaskFilesComponent,
    DudaSiteAdminSSOButtonComponent,
    ODataGridComponent,
    PublishOptionsComponent,
    ChecklistComponent,
    UpaChecklistComponent,
    LocalProfilesComponent,
    LocalProfileComponent,
    LocalProfileInitializationComponent,
    MinimumLocalProfileComponent,
    LocalProfileListComponent,
    ViewLocalProfilesComponent,
    ViewLocalProfileComponent,
    ViewLocalProfileListComponent,
    MinimumCustomerCampaignComponent,
    CustomerCampaignComponent,
    KeywordResearchComponent,
    VerticalSelectorComponent,
    GoogleIntegrationInfoComponent,
    GoogleIntegrationDiagnosticPanelComponent
  ]
})
export class SharedComponentsModule { }
